import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import { ContextService } from '../../services/context_service';
import { DatenauswertungEnergiekennzahlenBrowser } from './DatenauswertungEnergiekennzahlenBrowser';
import { DatenauswertungEnergiekennzahlenEmmission } from './DatenauswertungEnergiekennzahlenEmmission';
import { DatenauswertungEnergiekennzahlenKostenbezogen } from './DatenauswertungEnergiekennzahlenKostenbezogen';
import { DatenauswertungEnergiekennzahlenSpez } from './DatenauswertungEnergiekennzahlenSpez';
import { DatenauswertungEnergiekennzahlenVerbrauchsbezogen } from './DatenauswertungEnergiekennzahlenVerbrauchsbezogen';
import { disableKosten } from '../../helpers/showKosten';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { hasKennzahlenSpez } from './speziell/getKennziffernSpeziell';
import { i18n } from '../../i18n/i18n';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';

interface DatenauswertungEnergiekennzahlenProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortTid: number;
    standortName: string;
    jahrLast: number;
}

interface DatenauswertungEnergiekennzahlenState {
    tabIndex: number;
}

export class DatenauswertungEnergiekennzahlen extends
    React.Component<DatenauswertungEnergiekennzahlenProps, DatenauswertungEnergiekennzahlenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDatenauswertungEnergiekennzahlen') || 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disableKosten: boolean;

    componentDidMount(): void {
        this.disableKosten = disableKosten(this.props.data);
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDatenauswertungEnergiekennzahlen', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const extraRouting: any = {};
        if (this.props.routing && this.props.routing.path) {
            if (this.props.routing.path[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE] >= 0) {
                extraRouting[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE] = this.props.routing.path[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE];
            }
            if (this.props.routing.path[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM] >= 0) {
                extraRouting[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM] = this.props.routing.path[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM];
            }
        }
        const tabRoutings: any[] = [
            { path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN_SPEZ, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN_SPEZ, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_CO2_EMISSIONEN, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_BROWSER, ...extraRouting } }
        ];

        return (
            <Tabs
                className='tabs-datenauswertung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab disabled={this.disableKosten}>Allg. Energiekennzahlen (kostenbezogen)</Tab>
                    <Tab>Allg. Energiekennzahlen (verbrauchsbezogen)</Tab>
                    <Tab disabled={this.disableKosten || !hasKennzahlenSpez(this.props.data, 'kosten', this.props.standortTid)}>
                        Spez. Kennzahlen (kostenbezogen)
                    </Tab>
                    <Tab disabled={!hasKennzahlenSpez(this.props.data, 'verbrauch', this.props.standortTid)}>
                        Spez. Kennzahlen (verbrauchsbezogen)
                    </Tab>
                    <Tab>Emissionen (CO₂)</Tab>
                    <Tab disabled>Energiekennzahlen (Browser)</Tab>
                </TabList>
                <TabPanel>
                    {!this.disableKosten && <>
                        {getDefaultHelpIcon('datenauswertung_energiekennzahlen_kosten', i18n('Datenauswertung - Hinweise', 'sys'), this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungEnergiekennzahlenKostenbezogen
                            data={this.props.data}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            onRoutingChange={this.props.onRoutingChange}
                            jahrLast={this.props.jahrLast}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    <>
                        {getDefaultHelpIcon('datenauswertung_energiekennzahlen_verbrauch', i18n('Datenauswertung - Hinweise', 'sys'), this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungEnergiekennzahlenVerbrauchsbezogen
                            data={this.props.data}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            onRoutingChange={this.props.onRoutingChange}
                            jahrLast={this.props.jahrLast}
                        />
                    </>
                </TabPanel>
                <TabPanel>
                    {!(this.disableKosten || !hasKennzahlenSpez(this.props.data, 'kosten', this.props.standortTid)) && <>
                        {getDefaultHelpIcon('datenauswertung_energiekennzahlen_speziell_kosten', i18n('Datenauswertung - Hinweise', 'sys'), this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungEnergiekennzahlenSpez
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={this.props.jahrLast}
                            mode='kosten'
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {hasKennzahlenSpez(this.props.data, 'verbrauch', this.props.standortTid) && <>
                        {getDefaultHelpIcon('datenauswertung_energiekennzahlen_speziell_verbrauch', i18n('Datenauswertung - Hinweise', 'sys'), this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungEnergiekennzahlenSpez
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={this.props.jahrLast}
                            mode='verbrauch'
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    <>
                        {getDefaultHelpIcon('datenauswertung_emission', i18n('Datenauswertung - Hinweise', 'sys'), this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungEnergiekennzahlenEmmission
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={this.props.jahrLast}
                        />
                    </>
                </TabPanel>
                <TabPanel>
                    <DatenauswertungEnergiekennzahlenBrowser
                        data={this.props.data}
                        standortTid={this.props.standortTid}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
